const state = {
  statuses: []
}

const getters = {
  statuses (state) {
    return state.statuses.filter(status => status.is_show)
  },
  allStatuses (state) {
    return state.statuses
  }
}

const mutations = {
  SET_STATUSES (state, statuses) {
    state.statuses = statuses
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
